export default __webpack_public_path__ + "static/media/send-mail-8B8B8B.a44db83d.svg";